module.exports = __webpack_public_path__ + "img/Primordial-1-mobile.d149183c.png";